import { render, staticRenderFns } from "./footer-small.vue?vue&type=template&id=f379ae44&scoped=true"
import script from "./footer-small.vue?vue&type=script&lang=js"
export * from "./footer-small.vue?vue&type=script&lang=js"
import style0 from "./footer-small.vue?vue&type=style&index=0&id=f379ae44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f379ae44",
  null
  
)

export default component.exports